import { IconComponent } from './types';

const KeylineIcon: IconComponent = (props) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_615_6277"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="12"
      >
        <rect width="12" height="12" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_615_6277)">
        <path
          d="M1.526 0.507599H2.01152L4.01152 5.80415L2.01152 11.1007H1.526L3.526 5.80415L1.526 0.507599Z"
          fill="currentColor"
        />
        <path
          d="M2.51724 0.758621C2.51724 1.1776 2.1776 1.51724 1.75862 1.51724C1.33965 1.51724 1 1.1776 1 0.758621C1 0.339646 1.33965 0 1.75862 0C2.1776 0 2.51724 0.339646 2.51724 0.758621Z"
          fill="currentColor"
        />
        <path
          d="M4.51724 5.99995C4.51724 6.41893 4.1776 6.75857 3.75862 6.75857C3.33965 6.75857 3 6.41893 3 5.99995C3 5.58098 3.33965 5.24133 3.75862 5.24133C4.1776 5.24133 4.51724 5.58098 4.51724 5.99995Z"
          fill="currentColor"
        />
        <path
          d="M2.51724 11.2414C2.51724 11.6604 2.1776 12 1.75862 12C1.33965 12 1 11.6604 1 11.2414C1 10.8224 1.33965 10.4828 1.75862 10.4828C2.1776 10.4828 2.51724 10.8224 2.51724 11.2414Z"
          fill="currentColor"
        />
        <path
          d="M6.88858 0.488266H7.3741L9.3741 5.78482L7.3741 11.0814H6.88858L8.88858 5.78482L6.88858 0.488266Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default KeylineIcon;
